export default __webpack_public_path__ + "static/media/logo.ff9cbffa.png";